import {
  Autocomplete,
  Avatar,
  CircularProgress,
  FormLabel,
  TextField,
  Tooltip,
} from "@mui/material"
import { DataProvider, ListComponent } from "../GenericList"
import { DateTimeWidget, ImageWidget, LanguageDropdownWidget, SelectWidget } from "./CustomWidgets"
import { collection, getDocs, limit, query, startAfter, where } from "firebase/firestore"
import { useEffect, useState } from "react"

import { LocationCustomWidget } from "./LocationCustomWidget"
import React from "react"
import { db } from "../firebase"
import CustomObjectFieldTabs from "./raffle/CustomObjectFieldTabs"
import { locationUISchema } from "react-ui-components/components/location/locationUISchema"
import LocationSelector from "react-ui-components/components/location/LocationSelector"
import { UrlWidget } from "./UrlWidget"
import {
  getSponsorBusinessSlug,
  hasDuplicateSponsorSlug,
} from "./sponsorSlugUtils"

const AutocompleteWidget = (props: { value?: "" | undefined; onChange: any; id: any }) => {
  const { value = "", onChange, id } = props // Ensure value is always a string
  console.log("AutocompleteWidget value:", value)

  const [users, setUsers] = useState<any>([])
  const [userSearch, setUserSearch] = useState("")
  const [loadingUsers, setLoadingUsers] = useState(false)
  const [lastVisibleUser, setLastVisibleUser] = useState<any>(null)

  const fetchUsers = async (searchTerm = "", startAfterUser = null) => {
    setLoadingUsers(true)
    const usersRef = collection(db, "users")

    let userQuery = query(
      usersRef,
      where("name", ">=", searchTerm || ""), // Only fetch users where 'name' field exists and matches the search
      where("name", "<=", (searchTerm || "") + "\uf8ff"),
      limit(100),
    )

    if (startAfterUser) {
      userQuery = query(userQuery, startAfter(startAfterUser))
    }

    const querySnapshot = await getDocs(userQuery)
    const lastVisible = querySnapshot.docs[querySnapshot.docs.length - 1]
    setLastVisibleUser(lastVisible)

    const userList = querySnapshot.docs
      .map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }))
      .filter((user: any) => user.name) // Ensure the user has a name

    setUsers(userList)
    setLoadingUsers(false)
  }

  useEffect(() => {
    fetchUsers()
  }, [])

  const handleUserSearchChange = (event: any, value: any) => {
    setUserSearch(value)
    fetchUsers(value)
  }

  return (
    <Autocomplete
      options={users}
      value={users.find((user: any) => user.id === value) || null} // Find the selected user
      getOptionLabel={(option) => option.name || option.id || "Unknown User"}
      onChange={(event, newValue) => {
        onChange(newValue ? newValue.id : "") // Set the selected user's ID
      }}
      inputValue={userSearch}
      onInputChange={handleUserSearchChange}
      loading={loadingUsers}
      renderOption={(props, option) => (
        <li {...props} key={option.id}>
          {option.name || option.id || "Unknown User"}
        </li>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Select User"
          variant="outlined"
          fullWidth
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loadingUsers ? <CircularProgress color="inherit" size={20} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  )
}
const data = {
  getListLocation(id: any) {
    return ["sponsors"]
  },
  EDIT_TITLE: "Edit Sponsors",
  ADD_TITLE: "Add Sponsor",
  LOADING_MESSAGE: "Loading sponsors...",
  TITLE: "Sponsors",
  IMAGES_BUCKET: "sponsorsImages",

  onRowClick:
    (list: { [x: string]: any }, navigate: (arg0: string, arg1: { state: any }) => void) =>
    (
      arr: any,
      index: { dataIndex: string | number } /*: {rowIndex: number, dataIndex: number}*/,
    ) => {
      console.log("on row click----->", index.dataIndex)
      const state = list[index.dataIndex]
      const id = state.id
      navigate(`/sponsors/${id}`, { state })
    },

  columnsProperties: [
    { hidden: true, name: "id", label: "Id" },
    { required: false, name: "disabled", default: false, label: "Disabled", type: "boolean" },
    { required: false, name: "expirationDate", label: "Expiration Date" },

    { required: true, name: "name", label: "Name" },
    {
      required: false,
      name: "businessSlug",
      label: "Business Link Name",
    },
    { required: true, type: "integer", name: "order", label: "Order" },

    {
      type: "string",
      name: "iconUrl",
      label: "Icon URL",

      options: {
        customBodyRender: (value: string | undefined) => {
          return (
            <div className="flex flex-col flex-wrap overflow-auto w-40">
              {!value ? null : <img src={value} />}
            </div>
          )
        },
      },
    },
    {
      type: "string",
      name: "image",
      label: "Image URL",
      options: {
        customBodyRender: (value: string | undefined) => {
          return (
            <div className="flex flex-col flex-wrap overflow-auto w-40">
              {!value ? null : <img src={value} />}
            </div>
          )
        },
      },
    },

    { required: false, name: "description", label: "Description" },
    { required: true, name: "language", label: "Language" },
    { required: false, name: "hone", label: "Phone" },
    { required: false, name: "isWhatsApp", label: "Is Whats App", type: "boolean" },
    { required: false, name: "url", label: "URL" },
    {
      required: false,
      name: "location",
      default: {
        hidden: false,
        lat: "",
        lng: "",
        url: "",
        country: "",
        province: "",
        city: "",
        street: "",
        county: "",
        zipCode: "",
      },
      type: "object",
      properties: {
        hidden: { type: "boolean", title: "Hidden" },
        country: { type: "string", title: "Country" },
        province: { type: "string", title: "State" },
        city: { type: "string", title: "City" },
        street: { type: "string", title: "Street" },

        county: { type: "string", title: "County" },
        zipCode: { type: "string", title: "Zip Code" },

        url: { type: "string", title: "URL" },

        lat: { type: "string", title: "Lat" },
        lng: { type: "string", title: "Lng" },
      },
      options: {
        customBodyRender: (value: {
          [x: string]:
            | string
            | number
            | boolean
            | React.ReactElement<any, string | React.JSXElementConstructor<any>>
            | Iterable<React.ReactNode>
            | React.ReactPortal
            | Iterable<React.ReactNode>
            | null
            | undefined
        }) => {
          return (
            <div className="flex flex-col flex-wrap overflow-auto w-40">
              {!value
                ? null
                : Object.keys(value).map((k) => {
                    return (
                      <label>
                        <b>{k}:</b>
                        {value[k]}
                      </label>
                    )
                  })}
            </div>
          )
        },
      },
    },
    {
      required: false,
      name: "userIds",
      type: "array",
      items: {
        type: "string",
      },
      options: {
        customBodyRender: (value: any[]) => {
          return (
            <div className="flex flex-col flex-wrap overflow-auto w-40">
              {!value
                ? null
                : value.map(
                    (
                      item:
                        | string
                        | number
                        | boolean
                        | React.ReactElement<any, string | React.JSXElementConstructor<any>>
                        | Iterable<React.ReactNode>
                        | React.ReactPortal
                        | Iterable<React.ReactNode>
                        | null
                        | undefined,
                      i: number,
                    ) => {
                      return (
                        <label key={i}>
                          <b>
                            {i + 1}-{item}
                          </b>
                        </label>
                      )
                    },
                  )}
            </div>
          )
        },
      },
    },
  ],

  uiSchema: {
    url: { "ui:widget": "url" },
    businessSlug: {
      "ui:help":
        "Unique public link name. Example: salon-lourdes opens /sponsors/salon-lourdes.",
      "ui:placeholder": "salon-lourdes",
    },

    iconUrl: {
      "ui:widget": "image",
    },
    image: {
      "ui:widget": "image",
    },
    language: {
      "ui:widget": LanguageDropdownWidget,
    },
    location: {
      ...locationUISchema,
    },
    userIds: {
      items: {
        "ui:widget": AutocompleteWidget,
      },
    },
    expirationDate: {
      "ui:widget": "datetime",
    },

    description: {
      "ui:widget": "textarea",
    },
  },

  ObjectFieldTemplate: CustomObjectFieldTabs,

  async imageProcessor(
    fromData: { iconUrl: any; image: any; businessSlug?: string; publicSlug?: string; name?: string },
    handleUpload: (arg0: any, arg1: string, arg2: any) => any,
    id: any,
  ) {
    const businessSlug = getSponsorBusinessSlug(fromData)
    if (businessSlug) {
      const [businessSlugMatches, publicSlugMatches] = await Promise.all([
        getDocs(query(collection(db, "sponsors"), where("businessSlug", "==", businessSlug))),
        getDocs(query(collection(db, "sponsors"), where("publicSlug", "==", businessSlug))),
      ])
      const matchedDocs = [
        ...businessSlugMatches.docs.map((docSnap) => ({ id: docSnap.id })),
        ...publicSlugMatches.docs.map((docSnap) => ({ id: docSnap.id })),
      ]

      if (hasDuplicateSponsorSlug(matchedDocs, id)) {
        throw new Error(`Business link name "${businessSlug}" is already in use.`)
      }

      fromData.businessSlug = businessSlug
      fromData.publicSlug = businessSlug
    }

    if (fromData.iconUrl) {
      fromData.iconUrl = await handleUpload(id, this.IMAGES_BUCKET, fromData.iconUrl)
    }

    if (fromData.image) {
      fromData.image = await handleUpload(id, this.IMAGES_BUCKET, fromData.image)
    }

    return fromData
  },
  widgets: {
    url: UrlWidget,

    LocationSelector,
    SelectWidget,
    image: ImageWidget,
    datetime2: DateTimeWidget,
  },
}

const Sponsors = () => {
  return (
    <div>
      <DataProvider {...data}>
        <ListComponent />
      </DataProvider>
    </div>
  )
}
export default Sponsors
